export function getToken(userType) {
  let session = getObject(userType) || {};
  session = Object.keys(session).length && JSON.parse(session);
  let accessToken = session?.token || "";
  return accessToken;
}
export function getObject(key) {
  if (window && window.localStorage) {
    return window.localStorage.getItem(key);
  }
}
export function getEmail(userType) {
  let session = getObject(userType) || {};
  session = Object.keys(session).length && JSON.parse(session);
  let email = session?.activeUser || "";
  return email;
}
export function getName(userType) {
  let session = getObject(userType) || {};
  session = Object.keys(session).length && JSON.parse(session);
  let email = session?.activeUser || "";
  return email;
}

